import React,{useEffect, useState} from 'react'
import CollapseSection from '../../components/ui/CollapseSection'
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {sizes} from './fileTransferUtils';
import CustomLoadingScreen from '../../components/ui/CustomLoadingScreen';
//import SharedComponent from './SharedComponent';
import { useDispatch, useSelector } from "react-redux";
import {GetUserCountries,clearStatus,setState,GetQuotaFileStatus} from './fileTransferSlice';
import CustomButton from '../../components/ui/CustomButton';
import MessageSnackbar from "../../components/ui/MessageSnackbar";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

const fileTypes = [
	{ key: 1, value: "Quota" },
	{ key: 2, value: "Quota Modification" },
];

const QuotaFile = () => {
  
  const dispatch = useDispatch();
  const fileTransfer = useSelector((state) => state.fileTransfer);
  const {
    countries,
    isLoading,
    selectedCountry,
    selectedCountryID,
    quotaFileDate,
    qMStartDate,
    qMEndDate,
    isSuccess,
    isSuccess_Info,
    isAlert,
    isAlert_Info
  } = fileTransfer;

  const [selectedFileType,setSelectedFileType]=useState("");
  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });
  const minDate = dayjs();
  const maxDate = dayjs().add(3, 'month').endOf('month');
  const minQMDate = dayjs().startOf('month');
  const maxQMDate = dayjs().endOf('month');
  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  const handleCloseSnackbar=()=>{
    clearAlert();
  }
  const clearAlert = () => {
    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: ``,
    });
  };

  useEffect(() => {
    return () => {
      // Clear alert and success messages on unmount
      dispatch(setState("isSuccess", false));
      dispatch(setState("isSuccess_Info", ""));
      dispatch(setState("isAlert", false));
      dispatch(setState("isAlert_Info", ""));
    };
  }, []);

  useEffect(()=>{
    setSelectedFileType("");
    dispatch(setState("selectedCountry",""));
    dispatch(setState("selectedCountryID",""));
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  },[]);

  const setFileType=(event)=>{
    const fileType=event.target.value;
    setSelectedFileType(fileType);
    dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedCountryID", ""));
    // dispatch(setState("quotaFileDate",dayjs()));
    // dispatch(setState("qMStartDate",dayjs()));
    // dispatch(setState("qMEndDate",dayjs().add(1,"day")));
  }

  const setCountry=(event)=> {
      const name = event.target.value;
      let id = countries?.find((country) => country.countryName === name).countryID;
      dispatch(setState("selectedCountry", name));
      dispatch(setState("selectedCountryID", id));
    }

    const updateQuotaFileDate = (newDate) => {
     dispatch(setState("quotaFileDate",newDate));
    }
    const updateQuotaModificationStartDate = (newQMStartDate) => {
      dispatch(setState("qMStartDate",newQMStartDate));
     }
    const updateQuotaModificationEndDate = (newQMEndDate) => {
      dispatch(setState("qMEndDate",newQMEndDate));
     }

    const compactWeekDays = [8, 15, 22, 29];

    const isQuotaFileDateSelectable = (date) => {
      const d = dayjs(date);
      const today = dayjs();
      const dayOfMonth = d.date();
      if (dayOfMonth === 1 || dayOfMonth === 16) return true;
      if (compactWeekDays.includes(dayOfMonth)) return true;
      if (d.day() === 1) return true;
      if (d.isSame(today, "day")) return true;
      return false;
    };

    const disableDates = (date) => !isQuotaFileDateSelectable(date);

    const generateQuotaFile=()=>{
      if(selectedFileType === ""){
        displayAlert(true,"Please select a file type");
        return;
      }
      if(selectedCountry=== ""){
        displayAlert(true,"Please select a country");
        return;
      }
      let generationDate = "";
      let endDate = "";

      // If the file type is "Quota", check and validate the quotaFileDate
      if(selectedFileType==="Quota"){
        if (!dayjs(quotaFileDate).isValid()) {
          displayAlert(true,"Please select a date");
          return;
        }
        const genDt = new Date(dayjs(quotaFileDate).startOf("day").toDate());
        const maxDate = new Date(dayjs().add(3, "months").endOf("month").toDate());
        const minDate = new Date(dayjs().startOf("day").toDate());

        if (
          !isQuotaFileDateSelectable(genDt) ||
          genDt > maxDate ||
          genDt < minDate
        ) {
          displayAlert(true, "This date is not allowed");
          return;
        }
    
        generationDate = dayjs(genDt).format("YYYY-MM-DD"); // Set the valid generation date
      }
      if(selectedFileType==="Quota Modification"){
        if (!dayjs(qMStartDate).isValid()) {
          displayAlert(true,"Please select Modification Start Date");
          return;
        }
        if (!dayjs(qMEndDate).isValid()) {
          displayAlert(true,"Please select Modification End Date");
          return;
        }
        const modStartDt = dayjs(qMStartDate).startOf("day").toDate();
        const modEndDt = dayjs(qMEndDate).startOf("day").toDate();
        const dateToday = new Date();
        const firstDay = new Date(dateToday.getFullYear(), dateToday.getMonth(), 1);
        const lastDay = new Date(dateToday.getFullYear(), dateToday.getMonth() + 1, 0);

         // Validate if the start date and end date are within the allowed range
        const minDateStart = firstDay;
        const maxDateEnd = lastDay;

        if (modStartDt < minDateStart || modStartDt > maxDateEnd) {
          displayAlert(true, "Start date is not allowed");
          return;
        }

        if (modEndDt < minDateStart || modEndDt > maxDateEnd) {
          displayAlert(true, "End date is not allowed");
          return;
        }
        // Validate that the end date is after the start date
        if (modStartDt > modEndDt) {
          displayAlert(true, "End date cannot be before the start date");
          return;
        }

        generationDate = dayjs(modStartDt).format("YYYY-MM-DD");
        endDate = dayjs(modEndDt).format("YYYY-MM-DD");
      }

       // request object
      const requestData = {
        countryID: selectedCountryID,
        FileType: selectedFileType,
        generationDate: generationDate,
        endDate: endDate,
        requestedUser: JSON.parse(localStorage.getItem("data"))?.email || "",
      };
      //console.log("The requested object is",requestData);

      dispatch(GetQuotaFileStatus(requestData));
    }
    const alertDuration=10000;
    const successDuration=10000;

    function queuePopMsgOnClose() {
      dispatch(setState("isAlert", false));
      dispatch(setState("isAlert_Info", ""));
    }
    function successPopMsgOnClose() {
      dispatch(setState("isSuccess", false));
      dispatch(setState("isSuccess_Info", ""));
    }

  return (
   <Box mt={3}>
      <CollapseSection title="Quota File Generation">
        <Box mt={3}>
         {/* Display success message */}
          {fileTransfer.isSuccess && (
            <MessageSnackbar
              message={fileTransfer.isSuccess_Info}
              severity="success"
              open={fileTransfer.isSuccess}
              onClose={successPopMsgOnClose}
              autoHideDuration={successDuration}
              sx={{
                position:"fixed",
                top:20,
                left:"50%",
                transform:"translateX(-50%)",
                width:"300px"
              }}
            />
          )}
      {/* Display info message */}
          {fileTransfer.isAlert && (
            <MessageSnackbar
              message={fileTransfer.isAlert_Info}
              severity="info"
              open={fileTransfer.isAlert}
              onClose={queuePopMsgOnClose}
              autoHideDuration= {alertDuration}
              sx={{
                position:"fixed",
                top:100,
                left:"50%",
                transform:"translateX(-50%)",
                width:"300px"
              }}
            />
          )}
         {/* Display alert message */}
        {alert.alertDisplay && (
            <MessageSnackbar
            message={alert.alertMessage}
            severity={alert.alertSeverity}
            open={alert.alertDisplay}
            onClose={handleCloseSnackbar}
          />
        )}
          <CustomLoadingScreen isLoading={isLoading} />
          {/* <SharedComponent /> */}
          <Grid container columns={12} columnGap={2} rowGap={2}>
            <Grid item sm={2}>
                <FormControl>
                <InputLabel>File Type</InputLabel>
                <Select
                  value={selectedFileType}
                  label="File Type"
                  sx={{
                    height: selectHeight,
                    width: selectWidth,
                    color: "black.main",
                    mt: 1,
                  }}
                  onChange={setFileType}
                >
                  {fileTypes.map((fileType, index) => {
                    return (
                      <MenuItem key={index} value={fileType.value}>
                        {fileType.value}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item sm={2}>
              <FormControl>
                <InputLabel>Country</InputLabel>
                <Select
                  value={selectedCountry}
                  label="Country"
                  sx={{
                    height: selectHeight,
                    width: selectWidth,
                    color: "black.main",
                    mt: 1,
                  }}
                  onChange={setCountry}
                >
                  {countries.map((country, index) => {
                    return (
                      <MenuItem key={index} value={country.countryName}>
                        {country.countryName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            {selectedFileType==='Quota' && <Grid item sm={2}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={minDate}
                    maxDate={maxDate}
                    label="Quota File Date"
                    value={quotaFileDate || null}
                    shouldDisableDate={disableDates}
                    onChange={(newValue) => updateQuotaFileDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: sizes.w300 }}
                      />
                    )}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Box>
				    </Grid>
            }

            {selectedFileType==='Quota Modification' && <Grid item sm={2}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={minQMDate}
                    maxDate={maxQMDate}
                    label="Quota Modification Start Date"
                    value={qMStartDate || null}
                    onChange={(newValue) => updateQuotaModificationStartDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: sizes.w300 }}
                      />
                    )}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Box>
				    </Grid>
            }

            {selectedFileType==='Quota Modification' && <Grid item sm={2}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={minQMDate}
                    maxDate={maxQMDate}
                    label="Quota Modification End Date"
                    value={qMEndDate || null}
                    onChange={(newValue) => updateQuotaModificationEndDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: sizes.w300 }}
                      />
                    )}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Box>
				    </Grid>
            }

            <Grid item sm={2}>
              <CustomButton onClick={generateQuotaFile} size="large">Generate Quota File</CustomButton>
            </Grid>
          </Grid>
        </Box>
      </CollapseSection>
   </Box>
  )
}

export default QuotaFile